import { CheckoutState } from '@hooks/use-checkout'
import { siteNameStore, splitProductDescription } from '@utils/analytics/common'
import { DetectSiteDomain } from '@utils/detect-site-domain'
import { getCurrentSynsisalRoute } from '@utils/get-synsisal-route'
import { CheckoutEventDTO, CheckoutEventTypes } from '../../../../types/analytics/analytics-data'

export const createAddPaymentInfoDTO = (
  data: CheckoutState,
  siteDomainInfo: DetectSiteDomain,
  promoCode?: string,
  paymentType?: string,
  previousRoute?: string,
): CheckoutEventDTO | undefined => {
  const { furnitureSite, synsisalSite } = siteDomainInfo

  if (!data) {
    return
  }

  if (furnitureSite) {
    return
  }

  return {
    event: CheckoutEventTypes.ADD_PAYMENT_INFO,
    ecommerce: {
      currency: 'USD',
      value: parseFloat(data.totals.total.replace('$', '').replace(',', '')),
      coupon: promoCode || '',
      payment_type: paymentType,
      items: data.items.map((item) => {
        const [name, color] = splitProductDescription(item.description)
        return {
          item_name: synsisalSite ? item.description : item.description.split(':').length > 1 ? name : item.description,
          item_id: item.metadata?.contentful_id,
          affiliation: siteNameStore,
          coupon: promoCode || '',
          currency: 'USD',
          price: parseFloat(item.netPrice.replace('$', '').replace(',', '')),
          ...(synsisalSite && { item_brand: 'synsisal' }), // Add brand if is synsisal (only for synsisal site
          item_category: synsisalSite ? `Custom Rugs samples` : item.metadata?.category || '',
          item_category2: item.metadata?.category2 || '', // Choose rug type or carpet
          item_category3: item.metadata?.category3 || '', // choose border material
          item_category4: item.metadata?.category4 || '', // type of rug pad user choose
          item_category5: item.metadata?.category5 || '', // choose weave color
          item_variant: synsisalSite ? color : item.metadata?.category5 || '', // color of the product
          item_stock_detail: 'In_stock',
          item_list_name: synsisalSite ? previousRoute ?? getCurrentSynsisalRoute() : item.metadata?.itemListName || '',
          ...(item.metadata?.index && { index: item.metadata?.index }),
          quantity: item.quantity,
        }
      }),
    },
  }
}
